import React from 'react';

import { Box, List, Typography } from '@mui/material';
import { CanAccess, NavigationLink } from 'components';
import { useIsMobile } from 'hooks';

import { MenuType } from 'types/app';

type Props = {
  menu: MenuType;
  isCollapsed: boolean;
};

export const NavigationMenu: React.FC<Props> = ({ menu, isCollapsed }) => {
  const isMobile = useIsMobile();

  return (
    <Box margin={isMobile ? '0rem 0.5rem' : '0rem 1rem 0rem 1rem'}>
      <List
        subheader={
          <Typography
            variant="subtitle1"
            textTransform="capitalize"
            marginLeft={isMobile ? '1.5rem' : '2.5rem'}
            marginBottom="0.3rem"
            textAlign="left"
            maxWidth="25rem"
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            display="block"
          >
            {!isCollapsed && menu.subHeader}
          </Typography>
        }
      >
        {menu.items.map((it, index) => (
          <CanAccess
            key={index}
            allowedFor={it.userRight}
            requiresFeature={it.planFeature}
          >
            <NavigationLink key={index} item={it} isCollapsed={isCollapsed} />
          </CanAccess>
        ))}
      </List>
    </Box>
  );
};
